export const columnDropdownValues = ["1/1", "1/2", "1/3"];

export function calculateColumnWidth(columnSize) {
  const numbers = columnSize?.split("/");
  return 12 / numbers[1];
}
